import { render, staticRenderFns } from "./UpdatePremium.vue?vue&type=template&id=09d67553"
import script from "./UpdatePremium.vue?vue&type=script&lang=js"
export * from "./UpdatePremium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports